module.exports = __webpack_public_path__ + "img/dash-side-icon.a50193a8.svg";